import React from "react";

function ProgressBar({
  totalScore,
  userPoints,
  questionNumber,
  totalQuestions,
  answered,
}) {
  return (
    <div className="progressbar">
      <progress
        max={totalQuestions}
        value={questionNumber + Number(answered !== null)}
      ></progress>
      <div className="progress">
        <p>
          Question
          <strong>
            {" "}
            {questionNumber + 1} / {totalQuestions}
          </strong>
        </p>
        <p>
          <strong>{userPoints}</strong> / {totalScore} Points
        </p>
      </div>
    </div>
  );
}

export default ProgressBar;
